module.exports = __webpack_public_path__ + "static/p3-fa378aacaf8980b0d2dbc234d61d1071.svg";